const {
  services,
  refreshTokenCookieName,
  jwtCookieName,
  sentryLogging,
  sentryEnvironment,
  appReleaseTag,
  guestProposalsPath,
} = window.env

export const ROUTES = {
  EVENT_HUB: '/',
  ALL_PROPOSALS: '/event',
  PROPOSAL: '/response',
  CONFIRMATION: '/confirmation',
  CONFIRMATION_V2: '/confirmationV2',
}

export const APP_RELEASE_TAG: string = appReleaseTag

export const APP_SENTRY_LOGGING: boolean = Boolean(sentryLogging)
export const APP_SENTRY_SERVICE: string = services.bisPlatSentryDSN
export const HEADER_SENTRY_SERVICE: string = services.sentryDSN
export const SENTRY_ENV: string = sentryEnvironment

export const GUEST_PROPOSALS_PATH: string | undefined = guestProposalsPath

// TODO: Improve sentry variable naming once smart book is retired
export const AUTH_SERVICE: string = services.auth
export const DIGITAL_PROPOSALS: string = services.digitalProposals
export const HOST_SERVICE: string = services.host
export const HEADBOX_ROOT_SERVICE: string = services.root
export const ASSET_SERVICE: string = services.assets
export const GOOGLE_MAPS_API = services.googleMapsApi
export const GOOGLE_MAPS = services.googleMaps
export const BRIEF_BUILDER: string = services.briefBuilder
export const LOGIN_LINK: string = services.login
export const JOURNEYS_SERVICE: string = services.journeys

export const GQL_GATEWAY: string = services.gqlGateway
export const BUSINESS_GATEWAY: string = services.businessGateway
export const REFRESH_TOKEN_COOKIE_NAME: string = refreshTokenCookieName
export const JWT_COOKIE_NAME: string = jwtCookieName

export const BIZ_GUEST_ROLES: string[] = ['administrator', 'manager', 'member']
export const HOST_ROLES: string[] = ['host', 'blackbox_host']

export const PASSWORD_RESET_TOKEN: string = 'reset_password_token'
export const PASSWORD_RESET_EMAIL: string = 'email'
export const NUMERAL_FORMAT = '0,0'
export const COST_FORMATTING = '0,0[.]00'

export type CurrencyCode = 'GBP' | 'USD' | 'AUD' | 'EUR'

type CurrencySymbol = '£' | '$' | '€'

export const CURRENCY_CODES_TO_CURRENCY_SYMBOLS: Record<CurrencyCode, CurrencySymbol> = {
  GBP: '£',
  USD: '$',
  AUD: '$',
  EUR: '€'
}
